import { TaftAppMenuItem } from '@/models/taftAppMenuItem';

export default class AppMenuService {
  private static taftAppMenu: TaftAppMenuItem[] = [
    {
      name: 'Reports',
      route: '/main/reports',
      icon: 'fa-chart-bar',
      permission: [],
      hasSubItems: true,
    },
    // {
    //   name: 'Filings',
    //   route: '/main/filings',
    //   icon: 'fa-file-alt',
    //   permission: [],
    //   hasSubItems: false,
    // },
    {
      name: 'Products',
      route: '/main/dashboard',
      icon: 'fa-shopping-bag',
      permission: [],
      hasSubItems: false,
    },
    {
      name: 'Settings',
      route: '/main/settings',
      icon: 'fa-cog',
      permission: [],
      hasSubItems: true,
    },
    {
      name: 'How-to',
      route: '/main/guides',
      icon: 'fa-book',
      permission: [],
      hasSubItems: true,
    },
    {
      name: 'Support',
      route: '/main/support',
      icon: 'fa-question-circle',
      permission: [],
      hasSubItems: false,
    },
  ];

  private static ministryAppMenu = [
    {
      name: 'Reports',
      route: '/ministry/reports',
      subItems: [
        {
          name: 'Retailer sales history',
          subName: 'Individual sales',
          color: '#EEEBDA',
          icon: 'fa-store',
          iconColor: '#746139',
          route: '/ministry/reports/retailer-sales-history',
        },
        {
          name: 'Retailer sales summary',
          subName: 'Monthly totals',
          color: '#E9DDF1',
          icon: 'fa-file-chart-line',
          iconColor: '#6C5080',
          route: '/ministry/reports/retailer-sales-summary',
        },
        {
          name: 'Citizen sales history',
          subName: 'Status card lookup',
          color: '#EFE4DD',
          icon: 'fa-address-card',
          iconColor: '#664E3D',
          route: '/ministry/reports/citizen-sales-history',
        },
        {
          name: 'Band sales history',
          subName: 'All band purchases',
          color: '#D7EBEE',
          icon: 'fa-users',
          iconColor: '#338191',
          route: '/ministry/reports/band-sales-history',
        },
        {
          name: 'Denied adjudications',
          subName: 'All denied adjudications',
          color: '#e3bcbc',
          icon: 'fa-ban',
          iconColor: '#b32424',
          route: '/ministry/reports/denied-adjudications',
        },
        {
          name: 'High volume fuel sales',
          subName: 'All large volume fuel sales',
          color: '#afd8dd',
          icon: 'fa-gas-pump',
          iconColor: '#048191',
          route: '/ministry/reports/high-volume-fuel-sales',
        },
        {
          name: 'Multiple fuel sales monthly',
          subName: 'Status with multiple fuel sales',
          color: '#eac9c7',
          icon: 'fa-gas-pump',
          iconColor: '#734746',
          route: '/ministry/reports/multiple-fuel-sales-monthly',
        },
      ],
    },
    {
      name: 'Tasks',
      route: '/ministry/task-list',
      subItems: [
        {
          name: 'Pending Status Numbers',
          subName: 'Numbers requiring approval',
          color: '#DFF1DD',
          icon: 'fa-list',
          iconColor: '#2E8540',
          route: '/ministry/task-list/pending-status-numbers',
        },
        {
          name: 'Special Authorization Form',
          subName: 'For over-quota tobacco purchases',
          color: '#f8dcdc',
          icon: 'fa-align-justify',
          iconColor: '#f26674',
          route: '/ministry/task-list',
        },
      ],
    },
  ];

  static getMenuItems() {
    return this.taftAppMenu;
  }

  static getMinistryMenuItems() {
    return this.ministryAppMenu;
  }
}
